import React from 'react'
import { useSelector } from 'react-redux'
import Dialog from '../Dialog'
import $t from 'i18n'

const UnauthorizedModal = () => {
  const shouldShowErrorModal = useSelector(
    state => state.app.shouldShowUnauthorizedModal
  )

  return (
    <Dialog
      isVisible={shouldShowErrorModal}
      className='system-unauthorized-dialog'
      title={$t('dialogs.unauthorizedError.title')}
      footerActions={[]}
    >
      <div className='system-unauthorized-dialog-content'>
        <div className='system-error-dialog-subtitle subtitle'>
          {$t('dialogs.unauthorizedError.description')}
        </div>
      </div>
    </Dialog>
  )
}

export default UnauthorizedModal
